import { useEffect } from 'react';

const useInitialData = ({ setDataList = () => { }, setLoading = () => { }, fetchData, payload }) => {
    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true);
                const data = await fetchData(payload);
                if (setDataList) setDataList(data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        };
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useInitialData;
